import { useState, useEffect } from 'react';
import { getCandidateFullProfileWithEdgeFunction } from '../api/candidateWithEdgeFunction';
import { CandidateProfile } from '../types';

export const useCandidateProfile = (candidateId: string | undefined) => {
  const [profile, setProfile] = useState<CandidateProfile | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!candidateId) {
      setProfile(null);
      return;
    }

    let isMounted = true;

    const fetchProfile = async () => {
      setLoading(true);
      setError(null);
      try {
        const { data, error: apiError } = await getCandidateFullProfileWithEdgeFunction(candidateId);
        if (!isMounted) return;

        if (apiError) {
          setError('Failed to load profile');
        } else {
          setProfile(data);
        }
      } catch (err: any) {
        if (isMounted) {
          setError('An unexpected error occurred');
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchProfile();

    return () => {
      isMounted = false;
    };
  }, [candidateId]);

  return { profile, loading, error };
};
